import { createRouter, createWebHistory } from "vue-router";
import LeaderboardPage from "@/features/leaderboard/pages/LeaderboardPage.vue";
import SettingsPage from "@/features/settings/pages/SettingsPage.vue";
import ChangelogPage from "@/features/changelog/pages/ChangelogPage.vue";
import NativeApprovalPage from "@/features/native-approval/pages/NativeApprovalPage.vue";
import AboutPage from "@/features/about/pages/AboutPage.vue";
import AboutV2Page from "@/features/about/pages/AboutV2Page.vue";

const routes = [
  { path: "/", name: "leaderboard", component: LeaderboardPage },
  { path: "/about", name: "about", component: AboutPage },
  { path: "/aboutv2", name: "about-v2", component: AboutV2Page },
  { path: "/settings", name: "settings", component: SettingsPage },
  { path: "/changelog", name: "changelog", component: ChangelogPage },
  { path: "/native/approve", name: "native-approve", component: NativeApprovalPage },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

export default router;
